"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ICON_CONFIGS = void 0;
exports.IconConverter = IconConverter;
exports.IconWrapper = IconWrapper;
var DEFAULT_ICON_CONFIGS = exports.DEFAULT_ICON_CONFIGS = {
  tag: 'i',
  size: '1em',
  strokeWidth: 4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  rtl: false,
  theme: 'outline',
  colors: {
    outline: {
      fill: 'currentColor',
      background: 'transparent'
    },
    filled: {
      fill: 'currentColor',
      background: '#FFF'
    },
    twoTone: {
      fill: 'currentColor',
      twoTone: '#2F88FF'
    },
    multiColor: {
      outStrokeColor: 'currentColor',
      outFillColor: '#2F88FF',
      innerStrokeColor: '#FFF',
      innerFillColor: '#43CCF8'
    }
  },
  prefix: 'i'
};
function guid() {
  return 'icon-' + ((1 + Math.random()) * 0x100000000 | 0).toString(16).substring(1);
}
var getColor = function getColor(fillColor, cfgColor) {
  var _fillColor$trim;
  if (fillColor !== null && fillColor !== void 0 && (_fillColor$trim = fillColor.trim()) !== null && _fillColor$trim !== void 0 && _fillColor$trim.length) {
    return fillColor;
  }
  if (cfgColor.trim().length) {
    return cfgColor;
  }
  return 'currentColor';
};
function IconConverter(id, icon, config) {
  var _config$colors$outlin, _config$colors, _config$colors$outlin2, _config$colors2, _config$colors$filled, _config$colors3, _config$colors$filled2, _config$colors4, _config$colors$twoTon, _config$colors5, _config$colors$twoTon2, _config$colors6, _config$colors$twoTon3, _config$colors7, _config$colors$twoTon4, _config$colors8, _config$colors$multiC, _config$colors9, _config$colors$multiC2, _config$colors10, _config$colors$multiC3, _config$colors11, _config$colors$multiC4, _config$colors12, _ref, _icon$tag;
  var fill = typeof icon.fill === 'string' ? [icon.fill] : icon.fill || [];
  var colors = [];
  var theme = icon.theme || config.theme || DEFAULT_ICON_CONFIGS.theme;
  switch (theme) {
    case 'outline':
      colors.push(getColor(fill[0], (_config$colors$outlin = config === null || config === void 0 || (_config$colors = config.colors) === null || _config$colors === void 0 || (_config$colors = _config$colors.outline) === null || _config$colors === void 0 ? void 0 : _config$colors.fill) !== null && _config$colors$outlin !== void 0 ? _config$colors$outlin : DEFAULT_ICON_CONFIGS.colors.outline.fill));
      colors.push('transparent');
      colors.push(getColor(fill[0], (_config$colors$outlin2 = config === null || config === void 0 || (_config$colors2 = config.colors) === null || _config$colors2 === void 0 || (_config$colors2 = _config$colors2.outline) === null || _config$colors2 === void 0 ? void 0 : _config$colors2.fill) !== null && _config$colors$outlin2 !== void 0 ? _config$colors$outlin2 : DEFAULT_ICON_CONFIGS.colors.outline.fill));
      colors.push('transparent');
      break;
    case 'filled':
      colors.push(getColor(fill[0], (_config$colors$filled = config === null || config === void 0 || (_config$colors3 = config.colors) === null || _config$colors3 === void 0 || (_config$colors3 = _config$colors3.filled) === null || _config$colors3 === void 0 ? void 0 : _config$colors3.fill) !== null && _config$colors$filled !== void 0 ? _config$colors$filled : DEFAULT_ICON_CONFIGS.colors.filled.fill));
      colors.push(getColor(fill[0], (_config$colors$filled2 = config === null || config === void 0 || (_config$colors4 = config.colors) === null || _config$colors4 === void 0 || (_config$colors4 = _config$colors4.filled) === null || _config$colors4 === void 0 ? void 0 : _config$colors4.fill) !== null && _config$colors$filled2 !== void 0 ? _config$colors$filled2 : DEFAULT_ICON_CONFIGS.colors.filled.fill));
      colors.push('#FFF');
      colors.push('#FFF');
      break;
    case 'two-tone':
      colors.push(getColor(fill[0], (_config$colors$twoTon = config === null || config === void 0 || (_config$colors5 = config.colors) === null || _config$colors5 === void 0 || (_config$colors5 = _config$colors5.twoTone) === null || _config$colors5 === void 0 ? void 0 : _config$colors5.fill) !== null && _config$colors$twoTon !== void 0 ? _config$colors$twoTon : DEFAULT_ICON_CONFIGS.colors.twoTone.fill));
      colors.push(getColor(fill[1], (_config$colors$twoTon2 = config === null || config === void 0 || (_config$colors6 = config.colors) === null || _config$colors6 === void 0 || (_config$colors6 = _config$colors6.twoTone) === null || _config$colors6 === void 0 ? void 0 : _config$colors6.twoTone) !== null && _config$colors$twoTon2 !== void 0 ? _config$colors$twoTon2 : DEFAULT_ICON_CONFIGS.colors.twoTone.twoTone));
      colors.push(getColor(fill[0], (_config$colors$twoTon3 = config === null || config === void 0 || (_config$colors7 = config.colors) === null || _config$colors7 === void 0 || (_config$colors7 = _config$colors7.twoTone) === null || _config$colors7 === void 0 ? void 0 : _config$colors7.fill) !== null && _config$colors$twoTon3 !== void 0 ? _config$colors$twoTon3 : DEFAULT_ICON_CONFIGS.colors.twoTone.fill));
      colors.push(getColor(fill[1], (_config$colors$twoTon4 = config === null || config === void 0 || (_config$colors8 = config.colors) === null || _config$colors8 === void 0 || (_config$colors8 = _config$colors8.twoTone) === null || _config$colors8 === void 0 ? void 0 : _config$colors8.twoTone) !== null && _config$colors$twoTon4 !== void 0 ? _config$colors$twoTon4 : DEFAULT_ICON_CONFIGS.colors.twoTone.twoTone));
      break;
    case 'multi-color':
      colors.push(getColor(fill[0], (_config$colors$multiC = config === null || config === void 0 || (_config$colors9 = config.colors) === null || _config$colors9 === void 0 || (_config$colors9 = _config$colors9.multiColor) === null || _config$colors9 === void 0 ? void 0 : _config$colors9.outStrokeColor) !== null && _config$colors$multiC !== void 0 ? _config$colors$multiC : DEFAULT_ICON_CONFIGS.colors.multiColor.outStrokeColor));
      colors.push(getColor(fill[1], (_config$colors$multiC2 = config === null || config === void 0 || (_config$colors10 = config.colors) === null || _config$colors10 === void 0 || (_config$colors10 = _config$colors10.multiColor) === null || _config$colors10 === void 0 ? void 0 : _config$colors10.outFillColor) !== null && _config$colors$multiC2 !== void 0 ? _config$colors$multiC2 : DEFAULT_ICON_CONFIGS.colors.multiColor.outFillColor));
      colors.push(getColor(fill[2], (_config$colors$multiC3 = config === null || config === void 0 || (_config$colors11 = config.colors) === null || _config$colors11 === void 0 || (_config$colors11 = _config$colors11.multiColor) === null || _config$colors11 === void 0 ? void 0 : _config$colors11.innerStrokeColor) !== null && _config$colors$multiC3 !== void 0 ? _config$colors$multiC3 : DEFAULT_ICON_CONFIGS.colors.multiColor.innerStrokeColor));
      colors.push(getColor(fill[3], (_config$colors$multiC4 = config === null || config === void 0 || (_config$colors12 = config.colors) === null || _config$colors12 === void 0 || (_config$colors12 = _config$colors12.multiColor) === null || _config$colors12 === void 0 ? void 0 : _config$colors12.innerFillColor) !== null && _config$colors$multiC4 !== void 0 ? _config$colors$multiC4 : DEFAULT_ICON_CONFIGS.colors.multiColor.innerFillColor));
      break;
  }
  return {
    tag: (_ref = (_icon$tag = icon.tag) !== null && _icon$tag !== void 0 ? _icon$tag : config.tag) !== null && _ref !== void 0 ? _ref : DEFAULT_ICON_CONFIGS.tag,
    size: icon.size || config.size || DEFAULT_ICON_CONFIGS.size,
    strokeWidth: icon.strokeWidth || config.strokeWidth || DEFAULT_ICON_CONFIGS.strokeWidth,
    strokeLinecap: icon.strokeLinecap || config.strokeLinecap || DEFAULT_ICON_CONFIGS.strokeLinecap,
    strokeLinejoin: icon.strokeLinejoin || config.strokeLinejoin || DEFAULT_ICON_CONFIGS.strokeLinejoin,
    colors: colors,
    id: id
  };
}
function IconWrapper(name, rtl, _render) {
  var options = {
    name: 'icon-' + name,
    props: ['tag', 'size', 'strokeWidth', 'strokeLinecap', 'strokeLinejoin', 'theme', 'fill', 'spin'],
    data: function data() {
      return {
        id: guid(),
        ICON_CONFIGS: DEFAULT_ICON_CONFIGS
      };
    },
    render: function render(h) {
      var tag = this.tag,
        size = this.size,
        strokeWidth = this.strokeWidth,
        strokeLinecap = this.strokeLinecap,
        strokeLinejoin = this.strokeLinejoin,
        theme = this.theme,
        fill = this.fill,
        id = this.id,
        spin = this.spin,
        _this$ICON_CONFIGS = this.ICON_CONFIGS,
        ICON_CONFIGS = _this$ICON_CONFIGS === void 0 ? DEFAULT_ICON_CONFIGS : _this$ICON_CONFIGS;
      var svgProps = IconConverter(id, {
        tag: tag,
        size: size,
        strokeWidth: strokeWidth,
        strokeLinecap: strokeLinecap,
        strokeLinejoin: strokeLinejoin,
        theme: theme,
        fill: fill
      }, ICON_CONFIGS);
      var cls = ['kd-icon'];
      cls.push('kd-icon' + '-' + name);
      if (rtl && ICON_CONFIGS.rtl) {
        cls.push('kd-icon-rtl');
      }
      if (spin) {
        cls.push('kd-icon-spin');
      }
      var tagWrapper = svgProps.tag;
      return h(tagWrapper, {
        "class": cls.join(' '),
        "style": {
          lineHeight: 0
        }
      }, [_render(h, svgProps)]);
    }
  };
  return options;
}